import { tiktokProfileURLRegExp } from '../tiktokURLPattern';

export const parseTiktokSource = (input: string) => {
  const trimmedInput = input.trim();
  const match = trimmedInput.match(tiktokProfileURLRegExp);

  if (match) {
    return match[1] ?? '';
  }

  return trimmedInput.replace(/^@/, '');
};
